import React, { useState } from "react";
import { FileUploader } from "baseui/file-uploader";
import request from "../../utils/http";
import toaster from "../../utils/toaster";
import styled from "styled-components";
import { BsFileEarmark, BsLink45Deg } from "react-icons/bs";
import { Button } from "baseui/button";
import { Spinner } from "baseui/spinner";

const UploadCard = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	margin-bottom: 0.7rem;

	img,
	div {
		border-radius: 5px;
		margin: 0.7rem;
		width: 80%;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	}

	div {
		box-sizing: border-box;
		width: auto;
		max-width: 80%;
		padding: 0.7rem;
		> span {
			margin-left: 0.7rem;
			margin-right: 0.7rem;
		}
		> a {
			color: #000;
			position: relative;
			top: 2px;
		}
	}
`;

const FileUpload = (props: any) => {
	const [uploading, setUploading] = useState(false);
	const [replaceMode, setReplaceMode] = useState(false);

	const onDrop = (acceptedFiles: any, rejectedFiles: any) => {
		if (acceptedFiles.length >= 1) {
			setUploading(true);
			setReplaceMode(false);
			acceptedFiles.map((file: any) => uploadFile(file));
		}
		if (rejectedFiles.length >= 1) {
			toaster.error("Please only upload images or PDFs.");
		}
	};

	const uploadFile = async (file: any) => {
		let data = new FormData();

		for (let field in props.formFields) {
			data.append(field, props.formFields[field]);
		}

		data.append("uploadFile", file);

		let result = await request(
			"POST",
			props.targetUrl,
			data,
			true,
			false,
			true
		);

		if (result.success) {
			props.onChange(result.data);
		} else {
			if (result.message) {
				toaster.error(result.message);
			} else {
				toaster.error("Unable to upload your file.  Please try again later.");
			}
		}

		setUploading(false);
	};

	return (
		<>
			{uploading ? (
				<>
					<UploadCard>
						<Spinner />
					</UploadCard>
				</>
			) : (
				<>
					{props.value != null && props.value !== "" && props.value.privateUrl && (
						<>
							<UploadCard>
								{props.value.contentType &&
								props.value.contentType.startsWith("image/") ? (
									<>
										<img src={props.value.privateUrl} />
									</>
								) : (
									<>
										<div>
											<BsFileEarmark />
											<span>{props.value.fileName}</span>
											<a
												href={props.value.privateUrl}
												target="_blank"
												rel="noopener"
											>
												<BsLink45Deg />
											</a>
										</div>
									</>
								)}
							</UploadCard>
							<UploadCard>
								<Button
									kind="secondary"
									size="compact"
									onClick={() => {
										setReplaceMode(true);
									}}
								>
									Upload new file
								</Button>
							</UploadCard>
						</>
					)}
					{(replaceMode || props.value === "" || props.value == null) && (
						<>
							<FileUploader multiple={false} onDrop={onDrop} />
						</>
					)}
				</>
			)}
		</>
	);
};
export default FileUpload;
